import React from 'react';
import { ResourceListPage } from '../../components/resource/ResourceListPage';
import { etiquetasModelosService } from '../../services';
import { EtiquetaModelo } from '../../types/etiquetas';

export const EtiquetasModelosListPage: React.FC = () => {
  return (
    <ResourceListPage<EtiquetaModelo>
      title="Modelos de Etiquetas"
      service={etiquetasModelosService}
      columns={[
        { header: 'Nome', accessor: 'nome' },
        { header: 'Descrição', accessor: 'descricao' },
        { 
          header: 'Tipo Impressora', 
          accessor: 'tipo_impressora',
          render: (item) => item.tipo_impressora === 'zebra' ? 'Zebra' : 'Pimaco' 
        },
        { header: 'Largura (mm)', accessor: 'largura_mm' },
        { header: 'Altura (mm)', accessor: 'altura_mm' },
        { header: 'Por Linha', accessor: 'por_linha' },
        { header: 'Linhas', accessor: 'linhas' },
        { 
          header: 'Status',
          accessor: 'ativo',
          render: (item) => item.ativo ? 'Ativo' : 'Inativo'
        },
      ]}
      createPath="/admin/producao/etiquetas-modelos/novo"
      getEditPath={(item) => `/admin/producao/etiquetas-modelos/${item.id}`}
    />
  );
};
